import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { urlHasHashParam } from "drh-js-library/dist/drh-url-utils/url-has-hash-param";
import { DrhUrlParams } from "../../../system/constants/url/drh-url-params";

/**
 * Checks to see if the passed in url has all of the map params, they are
 *
 * - mlat
 * - mlng
 * - mzml
 * - mrad
 *
 * @param url The url to check for map settings.
 * @returns true if the passed in url contains all of the needed map params.
 */
export const urlHasLocationInfo = (url: string): boolean => {
	if (isStringEmpty(url)) {
		return false;
	}

	return (
		urlHasHashParam(url, DrhUrlParams.Latitude.paramName) &&
		urlHasHashParam(url, DrhUrlParams.Longitude.paramName) &&
		urlHasHashParam(url, DrhUrlParams.Radius.paramName) &&
		urlHasHashParam(url, DrhUrlParams.Zoom.paramName)
	);
};
